// src/shared/utils/formatDuration.js

export const MS_PER_MINUTE = 60 * 1000;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

/**
 * A short, human-readable length of time: "29d", "36h", "45m", "<1m".
 *
 * One unit, always rounded down, so the figure never promises time that is not
 * there — "29d" of a thirty-day grant rather than a hopeful "30d".
 *
 * Days are only used once there are at least two of them. Between 24 and 47
 * hours a single "1d" covers a day's worth of possibilities, and that range is
 * exactly where the remaining time starts to matter to whoever is reading it,
 * so those hours are spelled out instead.
 *
 * Returns null for anything that is not a usable span (null, NaN, negative),
 * leaving the caller to decide what absence should look like — "expired" and
 * "no expiry recorded" are not the same thing and should not share a dash here.
 */
export default function formatDurationShort(ms) {
  if (!Number.isFinite(ms) || ms < 0) return null;
  if (ms >= 2 * MS_PER_DAY) return `${Math.floor(ms / MS_PER_DAY)}d`;
  if (ms >= MS_PER_HOUR) return `${Math.floor(ms / MS_PER_HOUR)}h`;
  if (ms >= MS_PER_MINUTE) return `${Math.floor(ms / MS_PER_MINUTE)}m`;
  return '<1m';
}
